import * as Utils from './utils';

export default (node) => {
	const messages = node.querySelectorAll('.message');
	const datas = [];

	for (const message of messages) {
		var data = {
			'title': message.getAttribute('data-title'),
			'url': message.getAttribute('data-url'),
		}

		datas.push(data);

		message.addEventListener('mouseenter', (e) => {
			messages.forEach((el) => {
				if (el !== message) {
					el.classList.add('inactive');
					
				} else {
					el.classList.remove('inactive');
				}
			})
		});

		message.addEventListener('mouseleave', (e) => {
			messages.forEach((el) => {
				el.classList.remove('inactive');
			})
		});
	}

	Utils.storageSetValue('data-messages', JSON.stringify(datas));

};